<template>
    <label v-if="label" for="label">{{ label }}</label>
    <div class="p-inputgroup flex flex-row">
        <InputNumber v-model="minVal" placeholder="min" suffix=" min" :min="0" :max="59" :disabled="disabled" />
        <InputNumber v-model="secVal" placeholder="sec" suffix=" sec" :min="0" :max="59" :disabled="disabled" />
    </div>
</template>

<script>
export default {
    name: 'DurationInput',
    emits: ['duration-set'],
    props: {
        id: {
            type: Number,
            default: null,
        },
        label: {
            type: String,
        },
        modelValue: {
            type: [String, Number],
        },
        mode: {
            type: String,
        },
    },
    data() {
        return {
            disabled: false,
            minVal: null,
            secVal: null,
        };
    },
    watch: {
        minVal: {
            handler() {
                this.emitCombinedValue();
            },
        },
        secVal: {
            handler() {
                this.emitCombinedValue();
            },
        },
    },
    mounted() {
        if (this.modelValue) {
            this.loadMinutesSeconds();
        }
        if (this.mode && this.mode == 'disabled') {
            this.disabled = true;
        }
    },
    methods: {
        loadMinutesSeconds() {
            const totalSeconds = this.modelValue;
            this.minVal = parseInt(totalSeconds / 60);
            this.secVal = parseInt(totalSeconds % 60);
        },
        emitCombinedValue() {
            const minutes = this.minVal || 0;
            const seconds = this.secVal || 0;
            const totalSeconds = minutes * 60 + seconds;
            this.$emit('duration-set', { id: this.id, value: totalSeconds });
        },
    },
};
</script>
